<template>
  <v-container fluid>
    <v-navigation-drawer v-model="drawer" app dark class="sidebar-dark">
      <v-img width="100px" height="100px" class="rounded-circle mx-auto my-8 my-lg-4"
        :src="user.avatar !== null ? `https://api.mylegis.com.br/assets/${user.avatar}` : require('../assets/icon-person.svg')" />

      <h3 class="px-4 text-center white--text">
        {{user.first_name}}
      </h3>
      <v-list nav class="sidebar-menu">
        <v-list-item v-for="(item,x) in itemsMenu" :key="x" :to="{ name: item.route }" exact :exact-active-class="'v-list-item--active'" :active-class="'v-list-item--active'" class="menu-item mb-0">
          <v-list-item-action class="mr-3">
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout()" key="logout" class="menu-item">
          <v-list-item-content>
            <span class="white--text">Sair</span>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="white">mdi-logout</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container fluid>
        <v-row class="px-0" :class="intBreakPoint >= 2 ? `py-5 ` : ``">
          <v-col class="mt-0 pt-0 d-flex justify-space-between" v-if="intBreakPoint >= 2" cols="4">
            <div class="d-flex align-center">
              <v-icon color="#F15A24" class="mr-2" size="30">{{label.icon}}</v-icon>
              <h2 class="orange--text">{{label.title}}</h2>
            </div>
          </v-col>
          <v-col class="mt-0 pt-0 d-flex" v-if="intBreakPoint >= 2" cols="4">
            <div class="d-flex align-center">
              <v-carousel height="60" v-model="showBannerDestaque"  class="px-5" cycle :interval="10000" hide-delimiters :show-arrows="false">
                <small style="font-size:10px !important;">Patrocínio</small>
                <v-carousel-item v-for="b in banners" :key="b.directus_files_id">
                  <a :href="b.link" target="_blank">
                  <v-img :src="`https://api.mylegis.com.br/assets/${b.directus_files_id}`" class="mx-auto mb-10" width="300" contain height="45" />
                  </a>
                </v-carousel-item>
            </v-carousel> 
            </div>
          </v-col>

          <v-col class="mt-0 pt-0 d-flex justify-end" v-if="intBreakPoint >= 2" cols="4">
            <div class="d-flex align-center">
              <v-img src="../assets/logo.png" contain width="120px" height="50" />
            </div>
          </v-col>
          <v-col class="d-flex justify-start align-center" v-if="intBreakPoint <= 2">
            <v-app-bar-nav-icon class="justify-start" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          </v-col>

          <v-col class="mt-0 pt-0  justify-center d-flex" v-if="intBreakPoint < 2" cols="12" lg="6">
            <div class="d-flex align-center">
				<v-icon color="#F15A24" class="mr-2" size="30">{{label.icon}}</v-icon>
				<h2 class="orange--text">{{label.title}}</h2>
            </div>
          </v-col>
        </v-row>

        <!-- Barra de pesquisa -->

        <router-view></router-view>
        
        <!-- Modal de confirmação para excluir amizade -->


        <!-- Botão Como usar -->
        <v-btn fab small class="fixed-bottom-left" style=" background-color: #fda16bbe;" @click="showFaq = true">
          <v-icon color="white">mdi-help</v-icon>
        </v-btn>
        <span class="fixed-bottom-left-text">Como usar?</span>
        
        <!-- Dialog FAQ -->
        <DialogFaq :showFaq="showFaq" @update:showFaq="showFaq = $event" />
      </v-container>
    </v-main>
  </v-container>
</template>
<style scoped>

.fixed-bottom-left:hover{
	background-color: #ff6811 !important;
}

.fixed-bottom-left-text:hover{
	color: #ff6811 !important;
}

.sidebar-dark {
  background-color: #424242 !important;
}

.sidebar-menu {
  background-color: #424242;
}

.menu-item {
  border-bottom: 1px solid #666 !important;
  border-radius: 5px !important;
  max-width: 90%;
  margin:  3px auto;
  transition: background-color 0.3s ease;
}



::-webkit-scrollbar-track {
	background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
	background: v-bind('dynamicColor');
	border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
	background: v-bind('dynamicColor');
	opacity: 0.8;
}

/* Estilos adicionais para garantir que a barra de rolagem do menu seja estilizada */
.v-navigation-drawer {
	--scrollbar-color: v-bind(dynamicColor);
}

.v-list {
	--scrollbar-color: v-bind(dynamicColor);
}

.fixed-bottom-left {
  position: fixed !important;
  bottom: 20px !important;
  left: 20px !important;
  z-index: 1000;
}

.fixed-bottom-left-text {
  position: fixed !important;
  bottom: 20px !important;
  left: 80px !important;
  z-index: 1000;
  color: #fda16bbe;
  font-size: 14px;
  font-weight: 500;
}



.search-container {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  margin: 0 auto;
}

.search-field ::v-deep .v-input__slot {
  border-radius: 4px;
  background-color: white;
}

/* Estilos para o header */
.sponsor-logo {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sponsor-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sponsor-main {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.sponsor-separator {
  color: #F15A24;
  font-weight: bold;
  font-size: 16px;
}

.sponsor-sub {
  color: #F15A24;
  font-weight: 500;
  font-size: 12px;
}

.orange--text {
  color: #F15A24 !important;
}

.text-caption {
  font-size: 12px;
  color: #666;
}

.grey--text {
  color: #999 !important;
}

/* Estilos para o tema escuro */
.v-navigation-drawer--dark {
  background-color: #424242 !important;
}

.v-navigation-drawer--dark .v-list-item {
  color: white !important;
}

.v-navigation-drawer--dark .v-list-item:hover {
  background-color: #555 !important;
}

.v-navigation-drawer--dark .v-list-item--active {
  background-color: #666 !important;
}
</style>

<script>
	import '../assets/styles/scrollbar.css';
	import DialogFaq from '../components/DialogFaq.vue';
	export default {
		name: 'home',
		components: { DialogFaq },
		data() {
			return {
				showFaq: false,
				drawer: true,
				listActive: 0,
				qtdeNotifications: 0,
				items: [
					{ title: 'Feed', route: 'feed', icon: 'mdi-rss', color: '#a4a4a4' },
					{
						title: 'Legislações',
						route: 'legislacoes',
						icon: 'mdi-bookshelf',
						color: '#F15A24',
					},
					{
						title: 'Anotações',
						route: 'anotacoes',
						icon: 'mdi-pencil',
						color: '#a4a4a4',
					},
					// { title: "Favoritos", route: "favoritos", icon: "mdi-star" },
					{
						title: 'Grupos',
						route: 'grupos',
						icon: 'mdi-account-group',
						color: '#a4a4a4',
					},
					// { title: "Amigos", route: "amigos", icon: "mdi-account" },
					{
						title: 'Documentos',
						route: 'documentos',
						icon: 'mdi-file',
						color: '#a4a4a4',
					},
					{
						title: 'Perfil',
						route: 'perfil',
						icon: 'mdi-account-circle',
						color: '#F15A24',
					},
					{
						title: 'Lei',
						route: 'lei',
						icon: 'mdi-scale-balance',
						color: 'F15A24',
						hide: true,
					},
					{
						title: 'Projeto de Lei',
						route: 'projetoLei',
						icon: 'mdi-file-document',
						color: '#F15A24',
						hide: true,
					},
					{
						title: 'Grupo',
						route: 'gruposDetalhe',
						icon: 'mdi-account-group',
						color: '#F15A24',
						hide: true,
					},
					{
						title: 'Grupo - Arquivos',
						route: `grupoArquivos`,
						icon: 'mdi-folder',
						color: '#F15A24',
						hide: true,
					},

					{
						title: 'Crawler',
						route: 'crawler',
						icon: 'mdi-account-group',
						color: '#a4a4a4',
						hide: true,
					},
					{
						title: 'Usuário',
						route: 'Perfil Usuário',
						icon: 'mdi-account-group',
						color: '#a4a4a4',
						hide: true,
					},
					// { title: "Teste Word", route: "ckeditor", icon: "mdi-file-word" },
				],
				banners: [],
				showBannerDestaque: 0,
			};
		},
		computed: {
			dynamicColor() {
				return this.$route.params.id_grupo === '6f5ff131-006f-4525-9b17-75ae9674a09f' ? '#d8934e' : '#F15A24';
			},
			label() {
				let rout = this.items.filter((e) => e.route === this.$route.name);
				return rout[0] || { title: 'Projeto de Lei', icon: 'mdi-file-document' };
			},
			/*************  ✨ Codeium Command ⭐  *************/
			/**
			 * Determines if the current route is the home feed.
			 * @returns {boolean} True if the current route is 'feed', otherwise false.
			 */
			/******  4f6abd82-b4c9-44f8-aedb-4c90a9243f9e  *******/
			isHome() {
				return this.$route.name == 'feed';
			},
			isPerfil() {
				return this.$route.name == 'perfil';
			},
			user() {
				return this.$store.state.user != undefined
					? this.$store.state.user
					: { first_name: 'Meu Perfil' };
			},
			intBreakPoint() {
				switch (this.$vuetify.breakpoint.name) {
					case 'xs':
						return 0;
					case 'sm':
						return 1;
					case 'md':
						return 2;
					case 'lg':
						return 3;
					case 'xl':
						return 4;
					default:
						return 0;
				}
			},
			itemsMenu() {
				return this.items.filter((e) => !e.hide);
			},
		},
		watch: {
			'$route.params.id_grupo': {
				immediate: true,
				handler(newVal) {
					if (newVal === '6f5ff131-006f-4525-9b17-75ae9674a09f') {
						document.body.setAttribute('data-grupo', newVal);
					} else {
						document.body.removeAttribute('data-grupo');
					}
				}
			},
			dynamicColor: {
				immediate: true,
				handler(newColor) {
					document.documentElement.style.setProperty('--scrollbar-color', newColor);
					// Forçar atualização do estilo no menu
					const menu = document.querySelector('.v-navigation-drawer');
					if (menu) {
						menu.style.setProperty('--scrollbar-color', newColor);
					}
				}
			}
		},
		mounted() {
			this.$store.dispatch('getInfo');

			// this.$store.dispatch("getUsuarios");
			this.reloadBanners();
			
			// Configurar o atributo data-grupo inicial
			if (this.$route.params.id_grupo === '6f5ff131-006f-4525-9b17-75ae9674a09f') {
				document.body.setAttribute('data-grupo', this.$route.params.id_grupo);
			}
			
			// Configurar a cor inicial
			const color = this.dynamicColor;
			document.documentElement.style.setProperty('--scrollbar-color', color);
			
			// Forçar atualização do estilo no menu
			this.$nextTick(() => {
				const menu = document.querySelector('.v-navigation-drawer');
				if (menu) {
					menu.style.setProperty('--scrollbar-color', color);
				}
			});
		},
		beforeDestroy() {
			document.body.removeAttribute('data-grupo');
			document.documentElement.style.removeProperty('--scrollbar-color');
			const menu = document.querySelector('.v-navigation-drawer');
			if (menu) {
				menu.style.removeProperty('--scrollbar-color');
			}
		},
		methods: {
			async reloadBanners() {
				const { data } = await this.$http.get(
					`/items/banners/?fields=*,banners.*&filter[local][_eq]=painel`
				);
				this.banners = data.data[0] ? data.data[0].banners : [];
			},
			logout() {
				this.$store.dispatch('logout').then(() => {
					this.$router.push('/');
				});
			},
			openPerfil() {
				this.$router.push('/home/perfil');
			},
			openWhats() { 
				window.open("https://wa.me/5521991644663?text=Olá", "_blank")
			},
			sanitizeTitle(title) {
				var slug = '';
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
				// Letter "a"
				slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
				// Letter "o"
				slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
				// Letter "d"
				slug = slug.replace(/đ/gi, 'd');
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, '');
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, '-');

				return slug;
			},
		},
	};
</script>
